import {DefaultEdit} from "../../components/DefaultEdit";
import {EditProps} from "react-admin";
import {DocumentForm} from "./DocumentForm";

export const DocumentEdit = (props: EditProps) => {
  return (
      <DefaultEdit {...props}>
          <DocumentForm/>
      </DefaultEdit>

  )
};

